export interface ModooCarListFilterInterface {
	locations: string[];
	carTypes: string[];
}

export const modooEmptyCarListFilter: ModooCarListFilterInterface = { locations: [], carTypes: [] };

export interface ModooCarListDataInterface {
	userId: string;
	userName: string;
	userPhoneNum: string;
	userCarId: string;
	userCarLocation: string;
	userCarBrand: string;
	userCarNumber: string;
	userCarModelYear: number;
	userCarType: string;
	userCarWheelbase: string;
	userCarStatus: string;
	memberSetting: any;
}


export interface ModooCarListTableColumn {
	key: keyof ModooCarListDataInterface;
	title: string;
	width: number;
}